/// <reference path="../models/generated/SchadenmeldungSchadenmeldungKostenReponseApi.d.ts"/>
/// <reference path="../models/generated/SchadenmeldungTarifartKostenApi.d.ts"/>

import { AppUtils } from '../../shared/utils/index';
import { DokumentCheckConvertibleRequestApi } from "../models/generated/ModelsDokumentCheckConvertibleRequestApi";
import { BasicApplicationUrlBuilder } from "./BasicApplicationUrlBuilder";
import { DokumentUploadDatenApi } from "../models/generated/ModelsDokumentUploadDatenApi";
import { DamageDeclarationAdapter } from "../models/adapter/DamageDeclarationAdapter";
import { User } from "../models/api/User/User";

export class VesDamageApiService {
	protected readonly options: BasicAppOptions<VesDamageAppDefinition>;
	protected readonly applicationUrlBuilder: BasicApplicationUrlBuilder<VesDamageAppDefinition>;
	private readonly user: User;

	constructor(options: BasicAppOptions<VesDamageAppDefinition>, user: User) {
		this.options = options;
		this.user = user;
		this.applicationUrlBuilder = new BasicApplicationUrlBuilder(this.options);
	}

	public submitMailConfirmation(recipientEmail: string,
		timestamp: string,
		successCallback: () => void,
		errorCallback: () => void,
		attachmentIds?: string): void {

		AppUtils.Ajax.fragment({
			method: 'POST',
			url: this.options.app.apibestaetigungsmail,
			data: this.getSubmitMailParams(recipientEmail, timestamp, attachmentIds),
			contentType: "application/x-www-form-urlencoded;charset=utf-8"
		}, successCallback, errorCallback);
	}

	private getSubmitMailParams(recipientEmail: string, timestamp: string, attachmentIds?: string): { [key: string]: string } {
		let params;
		if (attachmentIds && attachmentIds.length > 0) {
			params = {
				"RecipientEmail": recipientEmail,
				"Timestamp": timestamp,
				"AttachmentIds": attachmentIds
			};
		}
		else {
			params = {
				"RecipientEmail": recipientEmail,
				"Timestamp": timestamp
			};
		}

		return params;

	}

	public checkConvertible(vorgangsnummer: string,
		fildIds: string[],
		successCallback: () => void,
		errorCallback: (jqxhr: JQuery.jqXHR) => void): void {


		const requestModel = new DokumentCheckConvertibleRequestApi();
		requestModel.Vorgangsnummer = parseInt(vorgangsnummer);
		requestModel.Dokumente = [];
		fildIds.forEach((id) => {
			const uploadDaten = new DokumentUploadDatenApi();
			uploadDaten.FileId = id;

			requestModel.Dokumente.push(uploadDaten);
		});

		AppUtils.Ajax.fragment({
			method: 'POST',
			url: this.applicationUrlBuilder.fullUrl(this.options.app.apicheckconvertible),
			data: requestModel.toRequestObject(),
			contentType: "application/x-www-form-urlencoded;charset=utf-8"
		}, successCallback, errorCallback, 60000);
	}

	public getVorgangsnummer(formId: string,
		successCallback: (data: ApiResponse<string>) => void,
		errorCallback: () => void): void {
		AppUtils.Ajax.fragment({
			method: 'GET',
			url: AppUtils.Url.updateUrlParameter({ FormId: formId }, this.applicationUrlBuilder.fullUrl(this.options.app.apivorgangsnummer)),
		}, successCallback, errorCallback);
	}

	/**
 * Sends Currency Sums to Api and get Limit of Costs
 */
	public getSchadenkosten(tarif: TarifartKostenApi, kostenSummen: { [id: string]: string },
		successCallback: (data: ApiResponse<SchadenmeldungKostenReponseApi>) => void,
		errorCallback: () => void): void {
		const req = DamageDeclarationAdapter.getKostenSummenRequest(tarif, kostenSummen);
		AppUtils.Ajax.fragment({
			method: 'POST',
			data: JSON.stringify(req.toRequestObject()),
			url: this.applicationUrlBuilder.fullUrl(this.options.app.apischadenkosten),
		}, successCallback, errorCallback);
	}

	public submitDamageDeclaration(requestObject: { [key: string]: any }, successCallback: (data: ApiResponse<SchadenmeldungResponseApi>, textStatus?: JQuery.Ajax.SuccessTextStatus, jqhxr?: JQuery.jqXHR) => void,
		errorCallback: (jqxhr?: JQuery.jqXHR, textStatus?: JQuery.Ajax.ErrorTextStatus, errorThrown?: string) => void, timeout?: number): void {
		if (this.user.Valid) {
			T.Utils.Auth.getBearerToken((token: string) => {
				AppUtils.Ajax.fragment({
					method: 'POST',
					url: this.applicationUrlBuilder.fullUrl(this.options.app.apischadenmeldung),
					headers: {
						Authorization: `Bearer ${token}`
					},
					data: JSON.stringify(requestObject)
				}, successCallback, errorCallback, timeout);
			});

		} else {
			AppUtils.Ajax.fragment({
				method: 'POST',
				url: this.applicationUrlBuilder.fullUrl(this.options.app.apischadenmeldung),
				data: JSON.stringify(requestObject)
			}, successCallback, errorCallback, timeout);
		}
	}

}
